import { clamp } from 'lodash';
import { curry, flow, filter, map, reduce } from 'lodash/fp'
import { some } from 'lodash';

const mapWithIndex = map.convert({
  cap: false,
});

import { MARKER_COLOURS } from "../../../constants";

const getFilteredAssets = filter(asset => !!asset.category.id);

const getTotalAssetsValues = reduce((acc, item) => acc + Math.abs(item.marketValue.value), 0);

const getPercentage = curry((total, value) => (100 * (Math.abs(value) / total)).toFixed(2));

const isAssetSelected = curry((selectedItem, categoryId) => (selectedItem && ((selectedItem.category && categoryId === selectedItem.category.id) || categoryId === selectedItem.id)));

const getMargetValue = value => value >= 0 ? clamp(value, 0.1, value) : value;

const getAssetColor = categoryId => {
  const assetStyles = MARKER_COLOURS[categoryId];
  if (assetStyles) {
    return assetStyles.fill
  }
  return null;
};

const prepareData = (getPercentage, isSelected) => mapWithIndex((asset, index) => {
  const marketValue = asset.marketValue.value;
  const { marketValue: { value: valueText }, category: { id: categoryId, name: categoryName }, allocation: { value } } = asset;

  return {
    value: getMargetValue(marketValue),
    percent: getPercentage(marketValue),
    displayPercent: value,
    valueText,
    titleText: categoryName,
    color: getAssetColor(categoryId),
    id: categoryId,
    selected: isSelected(categoryId),
    name: categoryName,
  };
});

const getTotalForFilteredAssets = flow(getFilteredAssets, getTotalAssetsValues);

export const getAssets = curry((assets, selectedPorfolioItem) => {
  const getAssetPercentage = getPercentage(getTotalForFilteredAssets(assets));
  return flow(getFilteredAssets, prepareData(getAssetPercentage, isAssetSelected(selectedPorfolioItem)))(assets);
});


const notEmptyArray = items => items.length > 0;

export const hasNegativeAssets = flow(filter(asset => asset.value < 0), notEmptyArray);
